import { Box } from "@mui/material";
import { getPayButtonLabel } from "Components/Customer/Payment/PaymentForms/payButtonUtils";
import { Colors } from "Components/Layout/Themes/Colors";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { useIsMobile } from "Hooks/useIsMobile";
import { useResource } from "Translations/Resources";

const MOBILE_SX = {
  py: 5,
  px: [5, 5, 2],
  left: 0,
  right: 0,
  bottom: 0,
  position: "fixed",
} as const;

type Props = {
  isDisabled: boolean;
  isLoading: boolean;
  totalAmount: number;
  currencyCode?: string;
};

export const PaySubmitButton = ({
  isDisabled,
  isLoading,
  totalAmount,
  currencyCode,
}: Props) => {
  const { t } = useResource();
  const isMobile = useIsMobile();

  return (
    <Box bgcolor={Colors.Gray} {...(isMobile ? MOBILE_SX : {})}>
      <PrimaryButton
        fullWidth
        type="submit"
        color="primary"
        disabled={isDisabled}
        isLoading={isLoading}
      >
        {getPayButtonLabel(t, totalAmount, currencyCode)}
      </PrimaryButton>
    </Box>
  );
};
